import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconLoadingSizeM from './FileIconLoading_size_m';
import FileIconLoadingSizeS from './FileIconLoading_size_s';

export const FileIconLoading = createFileIcon({
  m: FileIconLoadingSizeM,
  s: FileIconLoadingSizeS,
  name: 'FileIconLoading',
});
